<template>
  <div>
    <div class="page">
      <el-collapse v-model="activeNames" class="collapse-main-content">
        <el-collapse-item name="1">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>
              电表信息
            </div>
          </template>
          <div class="collapse-content">
            <sirui-search :query="form" :columns="formColumn" :isQueryPanel="false"></sirui-search>
            <el-form ref="form" :model="form">
              <el-form-item label="空间：" style="margin-left: 50px">
                <el-input v-model="form.spaceAreaName" style="width: 120px" disabled> </el-input>
                <el-input
                  v-if="form.spaceAssetName != ''"
                  v-model="form.spaceAssetName"
                  style="width: 120px; margin-left: 10px"
                  disabled
                >
                </el-input>
                <el-input
                  v-if="form.spaceUnitName != ''"
                  v-model="form.spaceUnitName"
                  style="width: 120px; margin-left: 10px"
                  disabled
                >
                </el-input>
                <el-input
                  v-if="form.spaceFloorName != ''"
                  v-model="form.spaceFloorName"
                  style="width: 120px; margin-left: 10px"
                  disabled
                >
                </el-input>
                <el-input
                  v-if="form.spaceName != ''"
                  v-model="form.spaceName"
                  style="width: 120px; margin-left: 10px"
                  disabled
                >
                </el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>
              电表抄表历史
            </div>
          </template>
          <div class="collapse-content">
            <el-button type="primary" @click="exportClick">导出</el-button>
            <vxe-table
              :data="detail"
              border
              align="center"
              header-align="center"
              show-footer
              :footer-method="footerMethod"
              style="margin-top: 20px; margin-bottom: 20px; width: 100%"
            >
              <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
              <vxe-table-column
                type:html
                v-for="item in columnListDefault"
                :field="item.field"
                :title="item.title"
                :key="item.field"
              >
                <template v-slot="{ row }">
                  <template v-if="item.field === 'attachments'">
                    <template v-if="row[item.field] != null && row[item.field].length != 0">
                      <el-button
                        type="text"
                        v-for="item in row[item.field]"
                        :key="item.attachmentId"
                        @click="downloadAttachments(item)"
                        style="color: blue; cursor: pointer"
                        >{{ item.attachmentName }}</el-button
                      >
                    </template>
                    <template v-else> 无 </template>
                  </template>
                  <!-- <template v-else-if="item.field === 'receivableSettlementNo'">
              <a @click="jumpToDetail(row)" href="#" style="color: blue; cursor: pointer">{{
                row[item.field]
              }}</a>
            </template> -->
                  <template v-else>{{ row[item.field] }}</template>
                </template>
              </vxe-table-column>
            </vxe-table>
            <div class="block">
              <el-pagination
                v-if="page.total > 0"
                background
                @size-change="handleSizeChange"
                @current-change="handlePagination"
                :page-count="page.pages"
                :current-page="page.pageNum || 1"
                :page-sizes="[1, 5, 10, 20]"
                :page-size="page.pageSize"
                :total="page.total"
                layout="sizes, prev, pager, next, jumper"
              ></el-pagination>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>
<script>
  import { detailColumns, detailTableColumn } from './columns/columns.js';
  import API from '@/api/property/meterManagement';
  export default {
    name: 'MeterReadDetail',
    computed: {
      formColumn() {
        return detailColumns(this);
      },
    },
    data() {
      return {
        activeNames: ['1', '2'],
        page: {
          pages: 1, //总共多少页
          pageNum: 1, //第几页
          pageSize: 5, //一页多少条数据
          total: 3, //总共多少条
        },
        columnListDefault: [],
        detail: [],
        form: {},
        meterNo: '',
      };
    },
    mounted() {
      this.meterNo = this.$route.query.meterNo;
      this.columnListDefault = detailTableColumn();
      this.getDetail();
      this.getHistory();
      //请求数据
    },
    methods: {
      // 底部合计
      footerMethod({ columns, data }) {
        const footerData = [
          columns.map((column, _columnIndex) => {
            if (_columnIndex === 0) {
              return '合计';
            }
            // if (column.property === 'domesticAmount') {
            //   return 0;
            // }
            if (column.property === 'currentMonthRead') {
              return data.reduce((cur, next) => cur + +next.currentMonthRead, 0).toFixed(2);
            } else if (column.property === 'loss') {
              return data.reduce((cur, next) => cur + +next.loss, 0).toFixed(2);
            } else if (column.property === 'totalDosage') {
              return data.reduce((cur, next) => cur + +next.totalDosage, 0).toFixed(2);
            }
            return null;
          }),
        ];
        return footerData;
      },
      // 电表详情
      async getDetail() {
        const { data } = await this.$axios.get(`${API.READ_DETAIL}/${this.meterNo}`);
        if (data.code == 0) {
          this.form = data.data.readRegisterVO;
          this.form.inductanceRatio = this.form.inductanceRatio
            ? '' + this.form.inductanceRatio
            : this.form.inductanceRatio;
          this.form.loss = this.form.loss ? '' + this.form.loss : this.form.loss;
          this.form.electricMeterType = data.data.electricMeter.meterType;
        }
      },
      // 获取抄表历史
      async getHistory() {
        let params = {
          electricMeterId: this.meterNo,
          pageSize: this.page.pageSize,
          pageNum: this.page.pageNum,
        };
        const { data } = await this.$axios.post(API.READ_QUERY_HISTORY, params);
        if (data.code == 0) {
          this.detail = data.data.records;
          this.page.pages = data.data.pages;
          this.page.total = data.data.total;
        }
      },
      // 导出
      async exportClick() {
        let params = {
          electricMeterId: this.meterNo,
          pageSize: this.page.pageSize,
          pageNum: this.page.pageNum,
        };
        const { data } = await this.$axios.post(API.READ_HISTORY_EXPORT, params);
        if (data.code === 0) {
          this.$message({
            showClose: true,
            message: data.msg,
            type: 'success',
          });
          window.location.href = data.data;
        } else {
          this.$alert(data.msg);
        }
      },
      handleSizeChange(val) {
        this.page.pageSize = val;
        this.getHistory();
      },
      handlePagination(val) {
        this.page.pageNum = val;
        this.getHistory();
      },
      // 下载附件
      downloadAttachments(row) {
        window.location.href = row.attachmentPath;
      },
      // 跳转结算详情
      jumpToDetail(row) {
        console.log(row);
      },
    },
  };
</script>
<style scoped lang="scss">
  .page {
    background-color: white;
    margin-top: 0px;
    padding: 20px;
    height: 100%;
    top: 0;

    .title {
      font-size: 20px;
      color: black;
      margin-left: 10px;
      margin-bottom: 10px;
      font-weight: bolder;
    }
  }

  .el-button {
    white-space: pre-line;
  }

  .el-table .cell {
    white-space: pre-line;
  }

  .el-form-item__label {
    font-size: 10px;
  }

  .bottomButtons {
    margin-top: 20px;
  }
</style>
